/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default {
  index: () => "/",
  payslip: {
    index: () => "/payslip",
  },
  balance: {
    index: () => "/balance",
  },
  retailerLocation: {
    index: () => "/retailerLocation",
  },
  paymentReceipt: {
    index: () => "/paymentReceipt",
  },
  payment: {
    index: () => "/payment",
    read: (paymentId: string) => `/payment/${paymentId}`,
  },
  payablePayment: {
    index: () => "/payable-payment",
  },
  unsubscribeAlerts: {
    index: () => "/unsubscribe",
    read: (email: string) => `/unsubscribe/${email}`,
  },
  recentPayments: {
    index: () => "/recentPayments",
  },
  payableRecentPayments: {
    index: () => "/payableRecentPayments",
  },
  directLanding: {
    index: () => "/landing",
  },
  payableDirectLanding: {
    index: () => "/payable-landing",
  },
  payableDetails: {
    index: () => "/payableDetails",
  },
  csrDirectLanding: {
    index: () => "/csr-payment-intent",
    read: (paymentIntentId: string) => `/csr-payment-intent/${paymentIntentId}`,
  },
  payableCsrDirectLanding: {
    index: () => "/payable-csr-payment-intent",
    read: (paymentIntentId: string) => `/payable-csr-payment-intent/${paymentIntentId}`,
  },
  linkExpired: {
    index: () => "/linkExpired",
  },
  terms: {
    index: () => "/terms",
  },
  privacy: {
    index: () => "/privacy",
  },
  notFound: {
    index: () => "/404",
  },
  barcode: {
    index: () => "/barcode",
  },
  rcpBarcode: {
    index: () => "/rcpBarcode",
  },
  lookup: {
    index: () => "/lookup",
  },
  invoiceList: {
    index: () => "/invoiceList",
  },
  payableDashboard: {
    index: () => "/payableDashboard",
  },
  rcpBarcodeView: {
    index: () => "/cash",
  },
  payableReview: {
    index: () => "/payableReview",
  },
  paymentSuccess: {
    index: () => "/paymentSuccess",
  },
};
